import { ReactElement } from 'react'
import illustration from '../images/Tonno4.jpg'
import StageContent from '../components/StageContent'
import StageTitle from '../components/StageTitle'
import StageText from '../components/StageText'
import StageOptions from '../components/StageOptions'

const options = [
  {
    text: 'Tämä seikkailu riitti minulle hyvin, ainakin hetkeksi.',
    gotoStage: 0
  },
  {
    text: 'Voisin käydä välillä kotona, mutta palaisin ihan pian.',
    gotoStage: 0
  },
  {
    text: 'Kyllä minua vielä kiinnostaisi tietää lisää kylästä. Ja jossakin on kuulemma ollut myös muinaisasutusta… en minä siis vielä voi lähteä kotiin.',
    gotoStage: 5
  }
]

interface Props {
  onStageChange: (stage: number) => void
}

const TonnoStage4 = ({ onStageChange }: Props): ReactElement => {
  return (
    <StageContent illustration={illustration}>
      <StageTitle small>Köydenvetoa sillalla</StageTitle>
      <StageText>
        Lähestytte siltaa, jonka molemmin puolin on kymmenisen henkilöä omissa porukoissaan jutustelemassa. Ihmettelet suurta väkijoukkoa, ja samassa joukosta vilkutetaan ystävällesi. Samassa joku tuo paikalle köyden. ”Meidän täytyy nyt kirjaimellisesti vetää yhtä köyttä, jotta voitamme vastapuolen. Periksi ei anneta, vaikka mikä tulisi!” joukkueen johtaja ohjeistaa juuri ennen köydenvedon alkua.
      </StageText>
      <StageText>
        ”Erä alkaa – 3, 2, 1, nyt!” Yllättäen veto ei alussa tuntunut kovin voimakkaalta, kun joukkueiden voimat ovat tasaväkiset. Todellinen kilpailu alkoi voimien ehtyessä. Minuutit tuntuivat matelevan. Toistelin mielessäni, että vielä jaksaa, vedä, vedä.. Sitten yhtäkkiä lensimme kaikki selällemme. ”Me voitimme!” iloitsin hyppien joukkueemme kanssa. Olihan kokemus!
      </StageText>
      <StageText>
        Mikään ei ollut koskaan tuntunut niin hyvältä, kuin jalkojen heiluttelu haaleassa vedessä kaiken tämän jälkeen. Se tunne levisi koko vartaloon kylminä väreinä ja yöttömän yön aurinko korosti tunnetta. ”Tuota kutsutaan Australiaksi, mutta sinne pitää uida.” Ystäväni osoitti edessämme näkyvää saarta ja naurahdin. ”Johan tässä on seikkailtu tarpeeksi tälle päivälle, katsotaan se Australia huomenna tarkemmin.”, sanon. Kellahdan selälleni laiturille ja suljen silmäni.
      </StageText>
      <StageText>
        <strong>Miten sinä jatkaisit tätä matkaa?</strong>
      </StageText>
      <StageOptions options={options} onSelect={onStageChange} />
    </StageContent>
  )
}

export default TonnoStage4
